import angular from 'angular';

import FinancialStatusWidgetContentComponent from './financial-status-widget-content-component';

export default angular
  .module('financial-status-widget-content', [])
  .component('financialStatusWidgetContent', new FinancialStatusWidgetContentComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/financial-status/components/financial-status-widget-content-module.js